import * as React from 'react'
import { IconButtonSeeker, useToaster } from 'ui-seeker/core'
import { useRemoveTaxes } from '../../hooks'

export default function IconRemoveTaxes({idLineSelected}) {

    const { showToaster } = useToaster()
    const { removeTaxes } = useRemoveTaxes()

	const handleClick = () => {
        showToaster.confirm(`Are you sure to remove selected taxes?`, {
            onSuccess: () => {
                removeTaxes(idLineSelected)
            },
            onCancel: () => {
                showToaster.error('Cancelled!')
            }
        })
        
	}

	return <IconButtonSeeker icon="trash-alt" iconType="fontAwesome" title="Remove taxes" onClick={handleClick} />
}